import React, { useEffect } from "react";
import "./App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "./LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Storia from "./components/Storia";
import Menu from "./components/Menu";
import Galleria from "./components/Galleria";
import Contatti from "./components/Contatti";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import HolidayPopup from "./components/HolidayPopup";

function useRevealOnScroll() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal-on-scroll");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function Shell() {
  useRevealOnScroll();
  return (
    <div className="min-h-screen bg-[#F5F2EC] text-[#23211E] font-sans">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Storia />
        <Menu />
        <Galleria />
        <Contatti />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <HolidayPopup />
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "'Outfit', sans-serif",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Shell />
    </LanguageProvider>
  );
}
